module.exports = __webpack_public_path__ + "static/media/doceria.c55dd068.jpg";